import React from 'react';
import PreLoginPage from '../core/PreLoginPage';
import $ from 'jquery';
import AdminModal from './AdminModal';
// import './SchoolRegStyle.css';
import NativeAjax from '../../util/NativeAjax';
import HmEventRegistry from '../../model/HmEventRegistry';

let schoolsAjaxTriggered = false;
let schoolsDataList = null;
class ContestPrelogin extends PreLoginPage {
	constructor(props) {
		super(props);
		this.state = { contestPreloginUrl: null, modalShow: true,showModalwindow:false,schoolsDataList: null };
		this.setContentSize = this.setContentSize.bind(this);
		this.getFrame = this.getFrame.bind(this);

		this.contestGrpId =
		this.props.match && this.props.match.params && !isNaN(this.props.match.params.contestGrpId)
		? this.props.match.params.contestGrpId
		: window.default_contest;

		this.selectedDiv = "";

		this.bindWindowFn();
	}

	componentDidMount() { 
		if(window.location.href.match(/#[a-zA-Z]+./) && window.location.href.match(/#[a-zA-Z]+./)[0] && window.location.href.match(/#[a-zA-Z]+./)[0].length > 1){
			this.selectedDiv = window.location.href.match(/#[a-zA-Z]+./)[0];
		}

		//console.log("componentDidMount CP");
		var me = this;
		$(window).resize(function() {
			me.setContentSize();
		});

		this.setState({
			contestPreloginUrl : me.getUrlFor('BLOG_URL')
		});

		$('body').css({ overflowY: 'hidden' });

		this.setContentSize();
		if(!schoolsAjaxTriggered){
			schoolsAjaxTriggered = true;
			this.getContestSchoolName();
		}		

		HmEventRegistry.fireEvent("INITIATE_GA");
		HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	}

	bindWindowFn() {
		let me = this;
		window.fireRegistration = () => {
			me.setState({ showModalwindow: true });
		};

		window.getAppUrl = (key) => {
			return me.getUrlFor(key);
		};
	}

	componentWillUnmount() {
		//console.log("componentWillUnmount")
		$('body').css({ overflowY: 'auto' });
	}

	setContentSize() {
		var me = this;
		//
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;
		if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
			//
			$('#contentIFrame').css('visibility', 'hidden');
			setTimeout(function() {
				$('#contentIFrame').css('visibility', 'visible');
				me.resizeCall();
			}, 1500);
			//
		}
		me.resizeCall();
	}
	//
	resizeCall() {
		//
		try {
			$('#contentIFrame').css({
				width  : window.innerWidth,
				height : window.innerHeight
			});
		} catch (e) {}
	}

	sendDocHeightMsg() {
		var ht = this.getDocHeight();
		window.postMessage(JSON.stringify({ docHeight: ht }), '*');
		//parent.postMessage( JSON.stringify( {'docHeight': ht} ), 'http://www.your-domain.com' );
	}

	getDocHeight(doc) {
		doc = doc || document;
		//console.log(doc);
		// from http://stackoverflow.com/questions/1145850/get-height-of-entire-document-with-javascript
		var body = doc.body,
		html = doc.documentElement;
		var height = Math.max(
			body.scrollHeight,
			body.offsetHeight,
			html.clientHeight,
			html.scrollHeight,
			html.offsetHeight
			);
		return height;
	}

	getContestGroup(){
		const host = this.getContestHost();

		if(host && host.length > 0 && window.contest_host_groups[host]){
			return window.contest_host_groups[host];
		}

		return host;
	}

	getFrame() {
		let me = this;

		if(!window.frame_urls || !window.frame_urls['contest']){
			return null;
		}

		const frameUrl = window.frame_urls['contest'][this.getContestGroup()] || window.frame_urls['contest']["ALL"];

		if (frameUrl) {
			return (
				<iframe
				id="contentIFrame"
				className="schoolRegForm"
				style={{ width: '100%', height: '100%' }}
				onLoad={() => {
					setTimeout(function() {
						me.setContentSize();
					}, 1500);
				}}
				ref="iframe"
				src={frameUrl + this.selectedDiv}
				width="100%"
				height="100%"
				scrolling="yes"
				frameBorder="0"
				/>
				);
		}
	}

	getContestSchoolName(){
		let me=this;
		var formData = {
			"countryCodeList":["SG"]
		}

		var callBackSuccess=function(response){
            //console.log("response school success ",response);
            if(response!==null){
            	if(response.status=="success"){
            		if(response.schoolsList){
            			schoolsDataList = response;
						//me.setState({schoolsDataList:response.schoolsList})
					}
				}
			}
			schoolsAjaxTriggered = false;
		}

		var callBackFailure=function(response){
			//console.log("response school failure",response);
			schoolsAjaxTriggered = false;
		}

		new NativeAjax(this.getUrlFor("CONTEST_TIC_GET_SCHOOL").replace("{#contestId}",this.getSelectedContestGroup())).enableCORS().get(callBackSuccess, callBackFailure);
       // console.log("getContestSchoolName CP");
       /*new NativeAjax((this.getUrlFor("CONTEST_TIC_GET_SCHOOL")+"?status=false"),formData).enableCORS().post(callBackSuccess, callBackFailure);*/
   }

   getSelectedContestGroup(){
   	let contestGrpParam = (this.props.match && this.props.match.params && this.props.match.params.contestGrpId) ? this.props.match.params.contestGrpId : localStorage.getItem("contestType");

   	if(contestGrpParam){
   		localStorage.setItem("contestType",contestGrpParam);
   	}else{
   		localStorage.setItem("contestType",window.default_contest);
   	}

   	return localStorage.getItem("contestType");
   }

   showModalwindow(){
   	let me=this;
   	if(this.state.showModalwindow){
   		return(
   			<AdminModal dataObj={schoolsDataList}
   			modalShow={this.state.modalShow}
   			type={'register'}
   			callBackParent={() => {
   				me.setState({ showModalwindow: false });
   			}}
   			/>
   			)
   	}
   }

   render() {
   	var me = this;
   	return (
   		<div>
   		<div id="schoolRegContent" style={{ overflow: 'hidden' }}>
   		{this.getFrame()}
   		{this.showModalwindow()}
					{/* <AdminModal
							modalShow={this.state.modalShow}
							type={'register'}
							callBackParent={() => {
								me.setState({ modalShow: false });
							}}
						/> */}
					{/* <SchoolRegForm></SchoolRegForm> */}
					</div>
					</div>
					);
   }
}

export default ContestPrelogin;



// WEBPACK FOOTER //
// ./src/views/registration/ContestPrelogin.js